import React, { useState } from "react";
import ResizableCell from "../Utility/ResizableCell";
import useAppStore from "../../store/global";
import { Link } from "react-router-dom";
import { formatHeader } from "../Utility/formatHeader";
import PendingReportModal from "./PendingReportModal";
import OnDemandModal from "./OnDemandModal";
import { Spinner, Form } from "react-bootstrap";
import { useMutation } from "@tanstack/react-query";
import { resetRestaurantClassification } from "./api";
import { toast } from "react-toastify";
import { useResetRestaurant } from "./api";
export default function RestaurantTable({
  restaurants,
  handleStartJob,
  handleStopJob,
  toggleLoading,
  togglingId,
  setTogglingId,
  checkJobStatus,
  autoSyncToggleHandler,
  SFTPToggleHandler
}) {
  const [expandedRows, setExpandedRows] = useState();
  const { restaurantId, setRestaurantId } = useAppStore();
  const [show, setShow] = useState(false);
  const [showOnDemand, setShowOnDemand] = useState(false);
  const [posForOnDemand, setPosForOnDemand] = useState([]);
  const [dateForOnDemand, setDateForOnDemand] = useState("");

  const { mutate, isPending } = useMutation({
    mutationFn: resetRestaurantClassification,
    onSuccess: (data) => {
      setTogglingId(null);
      toast.success(data.message);
    },
    onError: (error) => {
      toast.success(error.response.data.message);
      setTogglingId(null);
    }
  });

  const { mutate: resetRestaurant, isPending: resettingRestautant } =
    useResetRestaurant();

  const toggleRow = (id) => {
    const expandedIndex = expandedRows.indexOf(id);
    let newExpandedRows = [...expandedRows];

    if (expandedIndex >= 0) {
      newExpandedRows = expandedRows.filter((rowId) => rowId !== id);
    } else {
      newExpandedRows.push(id);
    }

    setExpandedRows(newExpandedRows);
  };

  const isRowExpanded = (id) => {
    return expandedRows == id;
  };

  if (!restaurants || restaurants.length === 0) {
    return <p>No restaurants available</p>;
  }
  const oheaders = Object.keys(restaurants[0]).filter((key) => key !== "_id");
  const desiredOrder = ["restaurant_id", "restaurant_name"];

  // Filter the headers based on the desired order
  const headers = desiredOrder.filter((header) => oheaders.includes(header));
  let pos_ids_required_for_sftp = ["c9132a27-f705-4796-9af3-4478144400de"];
  return (
    <>
      <div style={{ overflowX: "auto" }}>
        <table className="table table-striped table-hover table-bordered shadow-sm table-responsive table-stack">
          <thead>
            <tr>
              {headers.map((header) => (
                <th
                  key={header}
                  style={{
                    textAlign: "center",
                    textTransform: "capitalize"
                  }}
                >
                  <ResizableCell>{formatHeader(header)}</ResizableCell>
                </th>
              ))}
              <th
                style={{
                  textAlign: "center",
                  textTransform: "capitalize"
                }}
              >
                Manage POS
              </th>
              <th
                style={{
                  textAlign: "center",
                  textTransform: "capitalize"
                }}
              >
                On Demand Report
              </th>

              <th
                style={{
                  textAlign: "center",
                  textTransform: "capitalize"
                }}
              >
                Auto-Sync
              </th>
            </tr>
          </thead>
          <tbody>
            {restaurants.map((row) => (
              <React.Fragment key={row._id}>
                <tr
                  onClick={() => setExpandedRows(row._id)}
                  style={{ cursor: "pointer" }}
                >
                  {headers.map((header) => (
                    <td
                      data-label={formatHeader(header)}
                      style={{
                        textAlign: "center",
                        fontWeight: header === "restaurant_name" ? "bold" : ""
                      }}
                      key={header}
                    >
                      {row[header]}
                    </td>
                  ))}
                  <td
                    data-label="Manage POS"
                    className="stack-full"
                    style={{
                      textAlign: "center"
                    }}
                  >
                    {row["scrappers"].map((scrapper) =>
                      scrapper["current_status"] == "running" ? (
                        <div className="d-flex flex-wrap flex-sm-nowrap my-1 justify-content-center align-items-center">
                          <button
                            className="btn btn-sm btn-danger mx-2"
                            onClick={() => {
                              setTogglingId(scrapper.job_id);
                              handleStopJob(scrapper.job_id);
                            }}
                            style={{
                              width: "45%"
                            }}
                          >
                            Stop {scrapper.pos_name}
                            <Spinner
                              className="mx-2"
                              animation="border"
                              size="sm"
                            />
                          </button>
                          {pos_ids_required_for_sftp?.includes(
                            scrapper?.pos_id
                          ) && (
                            <Form
                              className="text-center mx-2 d-flex align-items-center  align-content-center gap-2"
                              style={{ cursor: "pointer" }}
                            >
                              <Form.Label>SFTP</Form.Label>
                              <Form.Check
                                type="switch"
                                title="SFTP"
                                id={`sftp-${row.restaurant_id}`}
                                checked={scrapper?.sftp_enabled}
                                onClick={(e)=>e.stopPropagation()}
                                onChange={(e) => {
                                  e.stopPropagation();
                                  SFTPToggleHandler(
                                    scrapper?.job_id,
                                    e.target.checked,
                                    row.restaurant_id
                                  );
                                }}
                              />
                            </Form>
                          )}
                        </div>
                      ) : (
                        <div className="d-flex flex-wrap flex-sm-nowrap my-1 justify-content-center align-items-center">
                          <button
                            className="btn btn-sm btn-primary mx-2"
                            onClick={() => {
                              setTogglingId(scrapper.job_id);
                              handleStartJob(scrapper.job_id);
                            }}
                            style={{
                              width: "45%"
                            }}
                          >
                            {toggleLoading &&
                              scrapper.job_id === togglingId && (
                                <Spinner
                                  className="mx-2"
                                  animation="border"
                                  size="sm"
                                />
                              )}
                            Start {scrapper.pos_name}
                          </button>

                          {pos_ids_required_for_sftp?.includes(
                            scrapper?.pos_id
                          ) && (
                            <Form
                              className="text-center mx-2 d-flex align-items-center  align-content-center gap-2"
                              style={{ cursor: "pointer" }}
                            >
                              <Form.Label>SFTP</Form.Label>
                              <Form.Check
                                type="switch"
                                title="SFTP"
                                id={`sftp-${row.restaurant_id}`}
                                checked={scrapper?.sftp_enabled}
                                onChange={(e) => {
                                  e.stopPropagation();
                                  SFTPToggleHandler(
                                    scrapper?.job_id,
                                    e.target.checked,
                                    row.restaurant_id
                                  );
                                }}
                              />
                            </Form>
                          )}
                        </div>
                      )
                    )}
                  </td>




                  <td
                    data-label="On Demand Report"
                    style={{
                      textAlign: "center"
                    }}
                  >
                    <button
                      className="btn btn-sm btn-primary mx-2"
                      onClick={() => {
                        setRestaurantId(row.restaurant_id);
                        setShowOnDemand(true);
                        console.log(row.scrappers);
                        setPosForOnDemand(row.scrappers);
                      }}
                    >
                      Extract
                    </button>
                  </td>

                  {/* Sftp */}

                  <td
                    data-label="Auto-Sync"
                    style={{
                      textAlign: "center"
                    }}
                  >
                    <Form className="text-center">
                      <Form.Check
                        type="switch"
                        id={`autoSyncToggle-${row.restaurant_id}`}
                        checked={row?.scrappers?.[0]?.auto_sync_flag}
                        onChange={(e) => {
                          autoSyncToggleHandler(
                            row.restaurant_id,
                            e.target.checked
                          );
                        }}
                      />
                    </Form>
                  </td>
                </tr>
                {isRowExpanded(row._id) && (
                  <tr>
                    <td
                      colSpan={headers.length + 3}
                      style={{
                        textAlign: "center"
                      }}
                    >
                      <div className="d-flex flex-wrap gap-2 justify-content-center">
                        <Link
                          to={`/restaurants/${row.restaurant_id}/menu-mix/?restaurant_name=${row.restaurant_name}`}
                        >
                          <button className="btn btn-sm btn-secondary shadow-sm mx-2">
                            Menu Mix
                          </button>
                        </Link>
                        <Link
                          to={`/restaurants/${row.restaurant_id}/labor-classification/?restaurant_name=${row.restaurant_name}`}
                        >
                          <button className="btn btn-sm btn-secondary shadow-sm mx-2">
                            Labor Classification
                          </button>
                        </Link>

                        <Link
                          to={`/restaurants/${row.restaurant_id}/discount-classification/?restaurant_name=${row.restaurant_name}`}
                        >
                          <button className="btn btn-sm btn-secondary shadow-sm mx-2">
                            Discount Classification
                          </button>
                        </Link>

                        <Link
                          to={`/restaurants/${row.restaurant_id}/discount-reports/?restaurant_name=${row.restaurant_name}`}
                        >
                          <button className="btn btn-sm btn-secondary shadow-sm mx-2">
                            View Discount Reports
                          </button>
                        </Link>
                        <Link
                          to={`/restaurants/${row.restaurant_id}/labour-reports/?restaurant_name=${row.restaurant_name}`}
                        >
                          <button className="btn btn-sm btn-secondary mx-2">
                            View Labour Reports
                          </button>
                        </Link>
                        <Link
                          to={`/restaurants/${row.restaurant_id}/sales-reports-v1/?restaurant_name=${row.restaurant_name}`}
                        >
                          <button className="btn btn-sm btn-secondary shadow-sm mx-2">
                            View Sales Reports
                          </button>
                        </Link>
                        <Link
                          to={`/restaurants/${row.restaurant_id}/sales-reports/?restaurant_name=${row.restaurant_name}`}
                        >
                          <button className="btn btn-sm btn-secondary shadow-sm mx-2">
                            View Sales Reports V2
                          </button>
                        </Link>
                        <Link
                          to={`/restaurants/${row.restaurant_id}/pmix-reports/?restaurant_name=${row.restaurant_name}`}
                        >
                          <button className="btn btn-sm btn-secondary mx-2">
                            View PMIX Reports
                          </button>
                        </Link>
                        <Link
                          to={`/restaurants/${row.restaurant_id}/upload-report/?restaurant_name=${row.restaurant_name}`}
                        >
                          <button className="btn btn-sm btn-secondary mx-2">
                            Upload Missing Report
                          </button>
                        </Link>
                        <button
                          className="btn btn-sm btn-info mx-2"
                          disabled={resettingRestautant}
                          onClick={() => {
                            setTogglingId(row.restaurant_id);
                            resetRestaurant(row.restaurant_id);
                          }}
                        >
                          {resettingRestautant &&
                            row.restaurant_id === togglingId && (
                              <Spinner
                                className="mx-2"
                                animation="border"
                                size="sm"
                              />
                            )}
                          Reset Data
                        </button>
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
      <PendingReportModal
        show={show}
        id={restaurantId}
        onHide={() => {
          setShow(false);
          setRestaurantId(null);
        }}
      />
      <OnDemandModal
        show={showOnDemand}
        id={restaurantId}
        onHide={() => {
          setShowOnDemand(false);
          setRestaurantId(null);
        }}
        posForOnDemand={posForOnDemand}
      ></OnDemandModal>
    </>
  );
}
